import O1HD from "../../../engines/gameEngine";
import normalMode from "../../normalMode/normalMode";
import spendMode from "../spendMode";

const {ccclass, property} = cc._decorator;
/**
 * 第二幕开始对话
 */
@ccclass
export default class PlotStartDialog extends cc.Component {

    @property(cc.Label)
    label: cc.Label = null;
    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;

    private mParentScript : spendMode ;

    onLoad () {}

    start () {
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    bindData( gameLayer : spendMode ){
        this.mParentScript = gameLayer;
        this.mParentScript.nextBtn.active = false;
    }

    /**
     * 开始挑战
     */
    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            this.mParentScript.nextBtn.active = true;
            //移动到圆梦房子
            this.mParentScript.moveToDreamHome();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }
}
